import React, { useEffect, useMemo, useRef, useState } from "react";
import Header from "../components/Header";

// 🎓 PROTÓTIPO "PARCEIROS DE CAPACITAÇÃO" (16/10/2026).
//
// Página escondida (/parceiros/demo, sem link no menu, noindex) para o Nelson mostrar a ideia a escolas e
// professores e tentar fechar os primeiros parceiros. TUDO aqui é dado de exemplo guardado só no navegador:
// nenhum candidato real, nenhum dado pessoal, nenhuma chamada à API do eaiRH. A ÚNICA coisa real é a sala de
// vídeo (Jitsi Meet público, gratuito), para o parceiro poder fazer uma aula de teste com o Nelson na hora.
//
// Regras de desenho que o protótipo já mostra (ver mokups/parceiros-capacitacao-completo.html):
//  - o curso NUNCA cita vaga, empresa nem contratação (Procon-MG, parecer 01/2025): bloco "Quer desenvolver X?";
//  - grátis primeiro; o parceiro aparece marcado como pago;
//  - o candidato pede um horário, ele fica reservado e o PARCEIRO APROVA (ou sugere outro) em até 24h;
//  - sem gravação e sem IA na aula; presença registrada quando cada pessoa entra e sai da sala.

const PARCEIRO = {
  nome: "Ana S.",
  titulo: "Inglês para tecnologia",
  sobre: "Aulas de conversação com foco no dia a dia de tecnologia. Horários flexíveis.",
  nota: 4.9,
  alunos: 18,
  vantagem: "1ª aula grátis para cadastrados no eaiRH",
  turmas: "Conversação · terças e quintas, 20h · online",
};

const HORARIOS = ["seg 20/10 · 19h", "qua 22/10 · 20h", "qui 23/10 · 19h", "sáb 25/10 · 10h"];

function Aba({ ativa, onClick, children }) {
  return (
    <button onClick={onClick}
      className={`px-4 py-2 rounded-full text-sm font-semibold border ${ativa ? "bg-brand text-white border-brand" : "bg-white text-text border-gray-200 hover:border-brand"}`}>
      {children}
    </button>
  );
}

function Selo() {
  return <span className="inline-block border border-green-700 text-green-700 rounded-md px-2 py-0.5 text-xs font-extrabold">✓ Recomendado pelos alunos</span>;
}

function Caixa({ titulo, children, rotulo }) {
  return (
    <section className="bg-white border border-gray-200 rounded-2xl p-5 mb-5">
      {rotulo && <div className="text-[11px] font-extrabold tracking-wider text-gray-400 uppercase mb-2">{rotulo}</div>}
      {titulo && <h2 className="text-lg font-bold text-text mb-3">{titulo}</h2>}
      {children}
    </section>
  );
}

// ---------------------------------------------------------------- visão do candidato
function VisaoCandidato({ pedido, setPedido, irParaSala }) {
  const [escolhido, setEscolhido] = useState(null);
  const [autorizo, setAutorizo] = useState(false);
  const [mostrarAgenda, setMostrarAgenda] = useState(false);

  return (
    <>
      <Caixa rotulo="Na página de uma vaga, abaixo da descrição e longe do botão de candidatura">
        <div className="font-extrabold text-text">Quer desenvolver inglês?</div>
        <p className="text-sm text-gray-500 mb-3">Opções para aprender, das gratuitas para as pagas.</p>
        <div className="flex items-center justify-between gap-3 border border-gray-200 rounded-xl p-3 mb-2">
          <div><b className="block text-sm">Inglês para iniciantes</b><span className="text-xs text-gray-500">Fundação Bradesco · online</span></div>
          <span className="text-xs font-extrabold bg-green-100 text-green-800 rounded-md px-2 py-1">GRATUITO</span>
        </div>
        <div className="flex items-center justify-between gap-3 border border-gray-200 rounded-xl p-3 mb-2">
          <div><b className="block text-sm">Conversação em inglês</b><span className="text-xs text-gray-500">Plataforma de cursos · online</span></div>
          <span className="text-xs font-extrabold bg-slate-100 text-slate-700 rounded-md px-2 py-1">PAGO</span>
        </div>
        <div className="flex flex-wrap items-center justify-between gap-3 border-2 border-accent bg-orange-50 rounded-xl p-3">
          <div className="flex gap-3 items-center">
            <div className="w-11 h-11 rounded-full bg-slate-200 flex items-center justify-center font-extrabold text-brand">AS</div>
            <div>
              <b className="block text-sm">{PARCEIRO.nome} · {PARCEIRO.titulo}</b>
              <span className="text-xs text-gray-500">Professora parceira · online · ★ {PARCEIRO.nota.toLocaleString("pt-BR")} ({PARCEIRO.alunos} alunos)</span>
              <div className="mt-1"><Selo /></div>
              <div className="text-xs font-bold text-brand mt-1">🎁 {PARCEIRO.vantagem}</div>
            </div>
          </div>
          <div className="text-right">
            <span className="text-xs font-extrabold bg-slate-100 text-slate-700 rounded-md px-2 py-1">PAGO</span>
            <div className="mt-2"><button onClick={() => setMostrarAgenda(true)} className="bg-accent text-white font-bold rounded-lg px-3 py-2 text-sm">Agendar aula grátis</button></div>
          </div>
        </div>
        <p className="text-xs text-gray-500 mt-2">Parceiros são verificados pelo eaiRH e avaliados por quem fez aula. O parceiro cobra pelas aulas dele; o eaiRH não recebe nada por isso.</p>
      </Caixa>

      {mostrarAgenda && !pedido && (
        <Caixa titulo={`Aula grátis com ${PARCEIRO.nome} · 30 min · online`}>
          <div className="text-sm text-gray-500 mb-2">Horários livres esta semana</div>
          <div className="flex flex-wrap gap-2 mb-4">
            {HORARIOS.map((h) => (
              <button key={h} onClick={() => setEscolhido(h)}
                className={`px-3 py-1.5 rounded-full text-sm border ${escolhido === h ? "bg-brand text-white border-brand" : "bg-white border-gray-300"}`}>{h}</button>
            ))}
          </div>
          <div className="text-sm text-gray-500">Turmas do curso (só para você saber se cabe na rotina; matrícula direto com a professora)</div>
          <div className="text-sm mb-3">{PARCEIRO.turmas}</div>
          <label className="flex gap-2 items-start text-sm mb-3">
            <input type="checkbox" checked={autorizo} onChange={(e) => setAutorizo(e.target.checked)} className="mt-1" />
            <span>Autorizo o eaiRH a enviar meu <b>nome e WhatsApp</b> para <b>{PARCEIRO.nome}</b>, só para esta aula. Posso retirar quando quiser.</span>
          </label>
          <button disabled={!escolhido || !autorizo} onClick={() => setPedido({ horario: escolhido, status: "aguardando" })}
            className="bg-accent text-white font-bold rounded-lg px-4 py-2 text-sm disabled:opacity-40">Pedir este horário</button>
        </Caixa>
      )}

      {pedido && (
        <Caixa titulo="Minha aula grátis">
          {pedido.status === "aguardando" && (
            <div className="text-sm">⏳ <b>Aguardando confirmação da {PARCEIRO.nome}</b> · {pedido.horario}. Ela confirma ou sugere outro horário em até 24 horas.
              <div className="text-xs text-gray-500 mt-1">No protótipo, abra a aba “Painel do parceiro” para aprovar.</div></div>
          )}
          {pedido.status === "sugerido" && (
            <div className="text-sm">
              <b>A {PARCEIRO.nome} sugeriu outro horário:</b> {pedido.sugestao} (no lugar de {pedido.horario}).
              <div className="flex gap-2 mt-2">
                <button onClick={() => setPedido({ horario: pedido.sugestao, status: "confirmada" })} className="bg-accent text-white font-bold rounded-lg px-3 py-1.5 text-sm">Aceitar</button>
                <button onClick={() => { setPedido(null); setMostrarAgenda(true); }} className="bg-slate-100 font-bold rounded-lg px-3 py-1.5 text-sm">Escolher outro</button>
              </div>
            </div>
          )}
          {pedido.status === "expirada" && (
            <div className="text-sm">
              <b>A {PARCEIRO.nome} não confirmou a tempo.</b> O horário de {pedido.horario} foi liberado.
              <div className="flex gap-2 mt-2">
                <button onClick={() => { setPedido(null); setMostrarAgenda(true); }} className="bg-accent text-white font-bold rounded-lg px-3 py-1.5 text-sm">Escolher outro horário</button>
                <button className="bg-slate-100 font-bold rounded-lg px-3 py-1.5 text-sm">Ver outros parceiros de inglês</button>
              </div>
            </div>
          )}
          {pedido.status === "confirmada" && (
            <div className="text-sm">
              ✅ <b>Aula confirmada</b> · {pedido.horario}. Você recebe um lembrete por e-mail (e WhatsApp, se autorizou).
              <div className="flex flex-wrap gap-2 mt-2">
                <button onClick={irParaSala} className="bg-accent text-white font-bold rounded-lg px-3 py-1.5 text-sm">Entrar na sala de aula</button>
                <button onClick={() => { setPedido(null); setMostrarAgenda(true); }} className="bg-slate-100 font-bold rounded-lg px-3 py-1.5 text-sm">Reagendar (até 12h antes)</button>
              </div>
            </div>
          )}
          {pedido.status === "realizada" && <Avaliacao />}
        </Caixa>
      )}
    </>
  );
}

function Avaliacao() {
  const [nota, setNota] = useState(0);
  const [enviada, setEnviada] = useState(false);
  const Op = ({ opcoes }) => {
    const [v, setV] = useState(null);
    return <span className="inline-flex gap-1 flex-wrap">{opcoes.map((o) => (
      <button key={o} onClick={() => setV(o)} className={`px-2.5 py-1 rounded-full text-xs border ${v === o ? "bg-brand text-white border-brand" : "border-gray-300"}`}>{o}</button>))}</span>;
  };
  if (enviada) return <div className="text-sm">Obrigado! Sua avaliação ajuda o próximo aluno a escolher bem.</div>;
  return (
    <div className="text-sm space-y-3">
      <div className="text-xs text-gray-500">Liberada só para quem esteve na sala (presença registrada).</div>
      <div>Como foi a aula com {PARCEIRO.nome}? {[1, 2, 3, 4, 5].map((n) => (
        <button key={n} onClick={() => setNota(n)} className={`text-xl ${n <= nota ? "text-accent" : "text-gray-300"}`}>★</button>))}</div>
      <div>Você se sentiu pressionado(a) a fechar matrícula? <Op opcoes={["Não", "Um pouco", "Sim"]} /></div>
      <div>Se quisesse parar, foi (ou seria) fácil cancelar? <Op opcoes={["Sim", "Não sei", "Não"]} /></div>
      <p className="text-xs text-gray-500">“Sim” para pressão ou “Não” para cancelar pausa o parceiro na hora, até a análise do eaiRH.</p>
      <button disabled={!nota} onClick={() => setEnviada(true)} className="bg-accent text-white font-bold rounded-lg px-4 py-2 text-sm disabled:opacity-40">Enviar avaliação</button>
    </div>
  );
}

// ---------------------------------------------------------------- visão do parceiro
function VisaoParceiro({ pedido, setPedido }) {
  const [enviado, setEnviado] = useState(false);
  return (
    <>
      <Caixa titulo="Painel do parceiro">
        <div className="mb-3 text-sm">Situação: <span className="bg-orange-100 text-orange-800 rounded-md px-2 py-0.5 text-xs font-extrabold">Período de teste · 2 de 5 avaliações</span></div>
        <div className="grid grid-cols-3 gap-3 mb-4">
          {[["7", "pedidos de aula grátis"], ["5", "aulas realizadas"], ["4,8 ★", "nota dos alunos"]].map(([n, t]) => (
            <div key={t} className="border border-gray-200 rounded-xl p-3"><b className="block text-2xl text-text">{n}</b><span className="text-xs text-gray-500">{t}</span></div>))}
        </div>
        {!pedido && <p className="text-sm text-gray-500">Nenhum pedido novo. (No protótipo: vá na aba “Visão do candidato”, peça um horário e volte aqui.)</p>}
        {pedido && pedido.status === "aguardando" && (
          <div className="border border-gray-200 rounded-xl p-3 text-sm">
            <b>Carla M.</b> pediu a aula grátis · {pedido.horario} · <span className="text-gray-500">expira em 23h</span>
            <div className="flex flex-wrap gap-2 mt-2">
              <button onClick={() => setPedido({ ...pedido, status: "confirmada" })} className="bg-accent text-white font-bold rounded-lg px-3 py-1.5 text-sm">Aprovar</button>
              <button onClick={() => setPedido({ ...pedido, status: "sugerido", sugestao: HORARIOS.find((h) => h !== pedido.horario) })} className="bg-slate-100 font-bold rounded-lg px-3 py-1.5 text-sm">Sugerir outro horário</button>
              <button onClick={() => setPedido({ ...pedido, status: "expirada" })} className="text-xs text-gray-500 underline">simular: não respondeu em 24h</button>
            </div>
          </div>
        )}
        {pedido && pedido.status === "confirmada" && <div className="text-sm">✅ Aula com <b>Carla M.</b> confirmada · {pedido.horario}.</div>}
        {pedido && pedido.status === "realizada" && <div className="text-sm">🟢 Aula realizada · presença registrada pela sala ✓</div>}
        <div className="mt-4 text-xs bg-orange-50 border border-orange-200 rounded-lg p-2">📅 Confirme seus horários da próxima semana até domingo, senão eles somem da sua agenda.</div>
      </Caixa>

      <Caixa titulo="Cadastro de parceiro (como o professor ou a escola entra)">
        {enviado ? <p className="text-sm">Recebido! O eaiRH confere o cadastro e avisa por e-mail. (Protótipo: nada foi enviado.)</p> : (
          <div className="grid md:grid-cols-2 gap-3 text-sm">
            <label>Nome ou escola<input className="w-full border rounded-lg px-3 py-2 mt-1" placeholder="Ex.: Ana Souza" /></label>
            <label>LinkedIn ou site<input className="w-full border rounded-lg px-3 py-2 mt-1" placeholder="linkedin.com/in/..." /></label>
            <label>Skills que ensina<input className="w-full border rounded-lg px-3 py-2 mt-1" defaultValue="Inglês, Inglês para TI" /></label>
            <label>CPF ou CNPJ (MEI)<input className="w-full border rounded-lg px-3 py-2 mt-1" placeholder="obrigatório para escola" /></label>
            <label className="md:col-span-2">Vantagem para cadastrados (obrigatória)<input className="w-full border rounded-lg px-3 py-2 mt-1" defaultValue="1ª aula grátis, individual, sem cartão e sem contrato" /></label>
            <label className="md:col-span-2">Agenda da aula grátis<input className="w-full border rounded-lg px-3 py-2 mt-1" defaultValue="seg e qua 19h–21h · sáb 10h–12h" /></label>
            <label className="md:col-span-2">Turmas do curso (informativo)<input className="w-full border rounded-lg px-3 py-2 mt-1" defaultValue={PARCEIRO.turmas} /></label>
            <div className="md:col-span-2 bg-slate-50 border rounded-xl p-3 text-xs leading-relaxed">
              <b>Compromissos do parceiro:</b> profissional independente, sem vínculo e sem intermediação de pagamento pelo eaiRH ·
              proibido associar o curso a vaga ou emprego, aqui ou na sua divulgação · proibido usar o nome do eaiRH sem autorização ·
              aula grátis individual, sem cartão e sem contrato · sem insistência para fechar · cancelamento simples · avaliação pública pelos alunos ·
              período de teste · responder pedidos em até 24h e cancelar só com 12h de antecedência.
            </div>
            <label className="md:col-span-2 flex gap-2 items-center"><input type="checkbox" defaultChecked /> Li e aceito os compromissos do parceiro</label>
            <div><button onClick={() => setEnviado(true)} className="bg-accent text-white font-bold rounded-lg px-4 py-2">Enviar para aprovação</button></div>
          </div>
        )}
      </Caixa>
    </>
  );
}

// ---------------------------------------------------------------- sala de aula (REAL: vídeo direto, sem conta)
// 17/10, terceira versão no mesmo dia:
//  1) meet.jit.si embutido: derruba em 5 min + aviso + login do moderador + propaganda ao sair;
//  2) JaaS (8x8) grátis: limpo, mas só 25 APARELHOS/mês no total — uma aula com 25 alunos esgota o mês;
//  3) AGORA: vídeo direto entre os dois navegadores (WebRTC, já embutido em todo navegador) com a biblioteca
//     PeerJS (código aberto). O vídeo vai de um aparelho ao outro, sem passar pelo servidor do eaiRH nem de
//     ninguém; o servidor gratuito do PeerJS só apresenta os dois no começo (meia dúzia de mensagens).
//     Sem conta, sem limite de usuários ou de tempo, sem aviso nem propaganda. Feito para 2 pessoas (aula grátis
//     individual). Em rede muito fechada (firewall corporativo) a ligação direta pode falhar: aí aparece a sala
//     reserva (meet.jit.si em aba própria, 95 min).
const PEERJS_URL = "https://cdn.jsdelivr.net/npm/peerjs@1.5.4/dist/peerjs.min.js";
const ICE = { iceServers: [{ urls: "stun:stun.l.google.com:19302" }, { urls: "stun:stun1.l.google.com:19302" }] };

function carregarPeerJs() {
  if (window.Peer) return Promise.resolve(window.Peer);
  return new Promise((ok, falha) => {
    const s = document.createElement("script");
    s.src = PEERJS_URL; s.async = true;
    s.onload = () => ok(window.Peer);
    s.onerror = () => falha(new Error("não carregou a biblioteca de vídeo"));
    document.body.appendChild(s);
  });
}

// `posicao` separado do resto: "relative" e "absolute" juntos na mesma classe brigavam e o vídeo pequeno caía
// embaixo do grande em vez de ficar no canto (print do Nelson, 17/10).
function Video({ stream, mudo, espelho, rotulo, posicao = "relative", className = "" }) {
  const ref = useRef(null);
  useEffect(() => { if (ref.current && ref.current.srcObject !== stream) ref.current.srcObject = stream || null; }, [stream]);
  return (
    <div className={`${posicao} bg-slate-900 overflow-hidden ${className}`}>
      {stream
        ? <video ref={ref} autoPlay playsInline muted={mudo} className={`w-full h-full object-cover ${espelho ? "-scale-x-100" : ""}`} />
        : <div className="absolute inset-0 flex items-center justify-center text-slate-400 text-sm px-4 text-center">Aguardando a outra pessoa entrar…</div>}
      <span className="absolute left-2 bottom-2 bg-black/60 text-white text-xs rounded px-2 py-0.5">{rotulo}</span>
    </div>
  );
}

function SalaDeAula({ sala, onRealizada }) {
  const [nome, setNome] = useState("");
  const [fase, setFase] = useState("fora"); // fora | entrando | aguardando | em-aula | erro
  const [erro, setErro] = useState("");
  const [local, setLocal] = useState(null);
  const [remoto, setRemoto] = useState(null);
  const [nomeRemoto, setNomeRemoto] = useState("Outra pessoa");
  const [mic, setMic] = useState(true);
  const [cam, setCam] = useState(true);
  const [log, setLog] = useState([]);
  const [houveAula, setHouveAula] = useState(false);
  const [confirmada, setConfirmada] = useState(false);
  const peerRef = useRef(null);
  const callRef = useRef(null);
  const palco = useRef(null);
  const telaCheia = () => {
    const el = palco.current;
    if (!el) return;
    if (document.fullscreenElement) document.exitFullscreen();
    else (el.requestFullscreen || el.webkitRequestFullscreen || (() => {})).call(el);
  };
  const localRef = useRef(null);
  const link = `${window.location.origin}/parceiros/demo?sala=${sala}`;
  const idSala = `eairh-aula-${sala}`;
  const hora = () => new Date().toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
  const anotar = (t) => setLog((l) => [...l, `${t} ${hora()}`]);

  const ligarChamada = (call, quem) => {
    callRef.current = call;
    call.on("stream", (s) => {
      setRemoto(s); setFase("em-aula"); setHouveAula(true);
      setNomeRemoto((n) => quem || n); anotar(`🟢 ${quem || "Outra pessoa"} entrou`);
    });
    call.on("close", () => { setRemoto(null); setFase((f) => (f === "fora" ? f : "aguardando")); anotar("⚪ a outra pessoa saiu"); });
    const pc = call.peerConnection;
    if (pc) pc.oniceconnectionstatechange = () => {
      if (pc.iceConnectionState === "failed") { setErro("A ligação direta não funcionou nesta rede."); setFase("erro"); }
    };
  };

  const entrar = async () => {
    setErro(""); setFase("entrando");
    let stream;
    try {
      stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
    } catch {
      setErro("Não deu acesso à câmera e ao microfone. Libere no navegador e tente de novo."); setFase("erro"); return;
    }
    localRef.current = stream; setLocal(stream); setMic(true); setCam(true);
    const quem = nome.trim() || "Convidado";
    try {
      const Peer = await carregarPeerJs();
      // Quem chega primeiro "abre" a sala com o nome dela; quem chega depois liga para esse nome.
      const anfitriao = new Peer(idSala, { config: ICE });
      peerRef.current = anfitriao;
      anfitriao.on("open", () => { setFase("aguardando"); anotar(`🟢 ${quem} (você) entrou`); });
      anfitriao.on("call", (call) => { call.answer(stream); ligarChamada(call, call.metadata && call.metadata.nome); });
      anfitriao.on("error", (e) => {
        if (e.type === "unavailable-id") {
          anfitriao.destroy();
          const visitante = new Peer({ config: ICE });
          peerRef.current = visitante;
          visitante.on("open", () => {
            anotar(`🟢 ${quem} (você) entrou`); setFase("aguardando");
            ligarChamada(visitante.call(idSala, stream, { metadata: { nome: quem } }), null);
          });
          visitante.on("error", () => { setErro("Não conseguimos conectar à sala."); setFase("erro"); });
        } else { setErro("Não conseguimos conectar à sala."); setFase("erro"); }
      });
    } catch (e) { setErro(e.message); setFase("erro"); }
  };

  const sair = () => {
    try { callRef.current && callRef.current.close(); } catch { /* já fechada */ }
    try { peerRef.current && peerRef.current.destroy(); } catch { /* já fechado */ }
    (localRef.current ? localRef.current.getTracks() : []).forEach((t) => t.stop());
    localRef.current = null; setLocal(null); setRemoto(null); setFase("fora");
    if (log.length) anotar("⚪ você saiu");
  };
  useEffect(() => () => sair(), []); // eslint-disable-line react-hooks/exhaustive-deps

  const alternar = (tipo) => {
    const trilhas = localRef.current ? (tipo === "mic" ? localRef.current.getAudioTracks() : localRef.current.getVideoTracks()) : [];
    const novo = !(tipo === "mic" ? mic : cam);
    trilhas.forEach((t) => { t.enabled = novo; });
    tipo === "mic" ? setMic(novo) : setCam(novo);
  };

  const dentro = fase === "aguardando" || fase === "em-aula";
  const reserva = `https://meet.jit.si/eairh-aula-${sala}`;

  return (
    <Caixa titulo="Sala de aula dentro do eaiRH (funciona de verdade)">
      <p className="text-sm text-gray-600 mb-3">Mande este link para quem vai fazer a aula de teste com você. Os dois entram na mesma sala, sem sair do eaiRH:</p>
      <div className="flex flex-wrap gap-2 items-center mb-4">
        <code className="bg-slate-100 rounded-lg px-3 py-2 text-xs break-all">{link}</code>
        <button onClick={() => navigator.clipboard && navigator.clipboard.writeText(link)} className="bg-slate-100 font-bold rounded-lg px-3 py-2 text-xs">Copiar link</button>
      </div>

      {!dentro && fase !== "entrando" && (
        <div className="flex flex-wrap gap-2 items-center">
          <input value={nome} onChange={(e) => setNome(e.target.value)} placeholder="Seu nome na sala" className="border rounded-lg px-3 py-2 text-sm" />
          <button onClick={entrar} className="bg-accent text-white font-bold rounded-lg px-4 py-2 text-sm">Entrar na sala</button>
        </div>
      )}
      {fase === "entrando" && <p className="text-sm text-gray-600">Ligando câmera e microfone… se o navegador perguntar, clique em <b>Permitir</b>.</p>}

      {dentro && (
        <>
          {/* Como numa chamada comum: a outra pessoa grande, você pequeno no canto; "Tela cheia" ocupa o monitor. */}
          <div ref={palco} className="relative bg-slate-900 rounded-xl overflow-hidden">
            <Video stream={remoto} rotulo={remoto ? nomeRemoto : "Sala aberta"} className="w-full aspect-video max-h-[75vh]" />
            <Video stream={local} mudo espelho rotulo={`${nome.trim() || "Você"}${cam ? "" : " · câmera desligada"}`}
              posicao="absolute" className="right-3 top-3 w-1/4 min-w-[7rem] aspect-video rounded-lg border-2 border-white/70 shadow-lg z-10" />
          </div>
          <div className="flex flex-wrap gap-2 justify-center mt-3">
            <button onClick={telaCheia} className="rounded-full px-4 py-2 text-sm font-bold bg-slate-100">⛶ Tela cheia</button>
            <button onClick={() => alternar("mic")} className={`rounded-full px-4 py-2 text-sm font-bold ${mic ? "bg-slate-100" : "bg-red-100 text-red-700"}`}>{mic ? "🎤 Microfone ligado" : "🔇 Microfone desligado"}</button>
            <button onClick={() => alternar("cam")} className={`rounded-full px-4 py-2 text-sm font-bold ${cam ? "bg-slate-100" : "bg-red-100 text-red-700"}`}>{cam ? "📷 Câmera ligada" : "🚫 Câmera desligada"}</button>
            <button onClick={sair} className="rounded-full px-4 py-2 text-sm font-bold bg-red-600 text-white">Sair da aula</button>
          </div>
        </>
      )}

      {fase === "erro" && (
        <div className="mt-3 border border-red-200 bg-red-50 rounded-xl p-3 text-sm">
          {erro}
          <div className="mt-2 flex flex-wrap gap-2">
            <button onClick={() => { sair(); setFase("fora"); }} className="bg-slate-100 font-bold rounded-lg px-3 py-1.5 text-xs">Tentar de novo</button>
            <a href={reserva} target="_blank" rel="noopener noreferrer" className="bg-accent text-white font-bold rounded-lg px-3 py-1.5 text-xs">Abrir sala reserva ↗</a>
          </div>
          <p className="text-xs text-gray-500 mt-1">A sala reserva abre numa aba própria (Jitsi gratuito, até 95 min).</p>
        </div>
      )}

      <div className="flex flex-wrap gap-x-4 gap-y-1 mt-4 text-xs text-gray-600">
        {log.length ? log.map((x, i) => <span key={i}>{x}</span>) : <span>A presença aparece aqui quando cada pessoa entra e sai.</span>}
        <span>🔴 Sem gravação</span>
      </div>

      {houveAula && fase === "fora" && !confirmada && (
        <div className="mt-4 border border-gray-200 rounded-xl p-3 text-sm">
          A aula aconteceu?
          <span className="inline-flex gap-2 ml-2">
            <button onClick={() => { setConfirmada(true); onRealizada(); }} className="bg-accent text-white font-bold rounded-lg px-3 py-1 text-xs">Sim, aconteceu</button>
            <button onClick={() => setConfirmada(true)} className="bg-slate-100 font-bold rounded-lg px-3 py-1 text-xs">Não aconteceu</button>
          </span>
        </div>
      )}
      {confirmada && <p className="mt-3 text-sm">Obrigado! No produto real, aluno e parceiro confirmam, e a avaliação fica liberada para o aluno.</p>}

      <p className="text-xs text-gray-500 mt-3">Vídeo direto entre os dois aparelhos: não passa pelo servidor do eaiRH, não tem custo, conta ou limite de tempo. Feito para aula individual.</p>
    </Caixa>
  );
}

// ---------------------------------------------------------------- sala de TURMA (Cloudflare Realtime)
// O vídeo de cada pessoa sobe UMA vez para a Cloudflare, que repassa a quem está na sala — aguenta turma, ao
// contrário do vídeo direto. O navegador nunca vê o segredo: fala com o "porteiro" do eaiRH (/api/sfu), que fala
// com a Cloudflare. Em teste no PC (localhost) a tela usa o porteiro do site, onde o token está no cofre.
// Fluxo (API oficial): sessão → publica câmera/microfone (tracks/new local) → a cada 3 s lista quem está na sala
// e assina as trilhas de quem chegou (tracks/new remote + renegociação). Consumo: a cada minuto, os bytes de vídeo
// recebidos (getStats) vão para o contador do mês; o porteiro trava turma nova perto do limite grátis.
const SFU = window.location.hostname === "localhost" ? "https://eairh.com.br/api/sfu" : "/api/sfu";
const TURMA_LIBERADA = window.location.hostname === "localhost";

async function sfu(caminho, metodo = "GET", corpo) {
  const r = await fetch(SFU + caminho, {
    method: metodo,
    headers: corpo ? { "Content-Type": "application/json" } : {},
    body: corpo ? JSON.stringify(corpo) : undefined,
  });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j.erro || j.errorDescription || `erro ${r.status}`);
  return j;
}

function SalaTurma({ sala }) {
  const [nome, setNome] = useState("");
  const [fase, setFase] = useState("fora"); // fora | entrando | dentro | erro
  const [erro, setErro] = useState("");
  const [local, setLocal] = useState(null);
  const [remotos, setRemotos] = useState({}); // sessionId -> { nome, stream }
  const [mic, setMic] = useState(true);
  const [cam, setCam] = useState(true);
  const [gb, setGb] = useState(null);
  const pcRef = useRef(null);
  const meuId = useRef(null);
  const localRef = useRef(null);
  const assinados = useRef(new Set());        // sessionIds cujas trilhas já pedimos
  const donoDoMid = useRef({});               // mid -> sessionId de quem publica
  const fila = useRef(Promise.resolve());     // uma negociação por vez (exigência do SFU)
  const timers = useRef([]);
  const ultimoBytes = useRef(0);
  const idSala = `turma-${sala}`;
  const link = `${window.location.origin}/parceiros/demo?sala=${sala}&modo=turma`;

  const emFila = (fn) => { fila.current = fila.current.then(fn, fn); return fila.current; };

  const assinar = (m) => emFila(async () => {
    const pc = pcRef.current;
    if (!pc || assinados.current.has(m.sessionId) || !m.trilhas || !m.trilhas.length) return;
    assinados.current.add(m.sessionId);
    try {
      const r = await sfu(`/sessao/${meuId.current}/trilhas`, "POST", {
        tracks: m.trilhas.map((t) => ({ location: "remote", sessionId: m.sessionId, trackName: t })),
      });
      if ((r.tracks || []).some((t) => t.errorCode)) { assinados.current.delete(m.sessionId); return; }
      (r.tracks || []).forEach((t) => { if (t.mid) donoDoMid.current[t.mid] = m.sessionId; });
      if (r.requiresImmediateRenegotiation && r.sessionDescription) {
        await pc.setRemoteDescription(r.sessionDescription);
        const resposta = await pc.createAnswer();
        await pc.setLocalDescription(resposta);
        await sfu(`/sessao/${meuId.current}/renegociar`, "PUT", { sessionDescription: { type: "answer", sdp: resposta.sdp } });
      }
    } catch { assinados.current.delete(m.sessionId); }
  });

  const medirConsumo = async () => {
    const pc = pcRef.current;
    if (!pc) return;
    let total = 0;
    (await pc.getStats()).forEach((s) => { if (s.type === "inbound-rtp") total += s.bytesReceived || 0; });
    const delta = total - ultimoBytes.current;
    ultimoBytes.current = total;
    if (delta > 0) { try { const r = await sfu("/consumo", "POST", { bytes: delta }); setGb(r.gbMes); } catch { /* tenta no próximo minuto */ } }
  };

  const atualizarSala = async () => {
    let membros;
    try { membros = await sfu(`/sala/${idSala}`, "POST", { sessionId: meuId.current, nome: nome.trim() || "Convidado", trilhas: ["audio", "video"] }); }
    catch { return; }
    const presentes = new Set(membros.map((m) => m.sessionId));
    setRemotos((atual) => {
      const novo = {};
      Object.entries(atual).forEach(([id, v]) => { if (presentes.has(id)) novo[id] = v; else assinados.current.delete(id); });
      membros.forEach((m) => { if (m.sessionId !== meuId.current && novo[m.sessionId]) novo[m.sessionId] = { ...novo[m.sessionId], nome: m.nome }; });
      return novo;
    });
    membros.filter((m) => m.sessionId !== meuId.current).forEach((m) => {
      setRemotos((atual) => (atual[m.sessionId] ? atual : { ...atual, [m.sessionId]: { nome: m.nome, stream: null } }));
      assinar(m);
    });
  };

  const entrar = async () => {
    setErro(""); setFase("entrando");
    try {
      const sit = await sfu("/situacao");
      if (!sit.configurado) throw new Error("A sala de turma ainda não foi configurada no painel admin.");
      if (!sit.liberado) throw new Error("Limite de vídeo do mês atingido. Use a sala reserva.");
      setGb(sit.gbMes);
      const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: { noiseSuppression: true, echoCancellation: true } });
      localRef.current = stream; setLocal(stream); setMic(true); setCam(true);
      const pc = new RTCPeerConnection({ iceServers: [{ urls: "stun:stun.cloudflare.com:3478" }], bundlePolicy: "max-bundle" });
      pcRef.current = pc;
      pc.ontrack = (e) => {
        const dono = donoDoMid.current[e.transceiver.mid];
        if (!dono) return;
        setRemotos((atual) => {
          const v = atual[dono] || { nome: "Participante", stream: null };
          const s = v.stream || new MediaStream();
          s.addTrack(e.track);
          return { ...atual, [dono]: { ...v, stream: new MediaStream(s.getTracks()) } };
        });
      };
      pc.oniceconnectionstatechange = () => {
        if (pc.iceConnectionState === "failed") { setErro("A conexão de vídeo caiu nesta rede."); setFase("erro"); }
      };
      const { sessionId } = await sfu("/sessao", "POST");
      meuId.current = sessionId;
      const transceivers = stream.getTracks().map((t) => pc.addTransceiver(t, { direction: "sendonly" }));
      const oferta = await pc.createOffer();
      await pc.setLocalDescription(oferta);
      const r = await sfu(`/sessao/${sessionId}/trilhas`, "POST", {
        sessionDescription: { type: "offer", sdp: oferta.sdp },
        tracks: transceivers.map((tr) => ({ location: "local", mid: tr.mid, trackName: tr.sender.track.kind })),
      });
      await pc.setRemoteDescription(r.sessionDescription);
      setFase("dentro");
      await atualizarSala();
      timers.current = [setInterval(atualizarSala, 3000), setInterval(medirConsumo, 60000)];
    } catch (e) { setErro(e.message || "Não conseguimos entrar na sala."); setFase("erro"); sair(true); }
  };

  const sair = (silencioso) => {
    timers.current.forEach(clearInterval); timers.current = [];
    if (meuId.current) { medirConsumo(); sfu(`/sala/${idSala}/sair`, "POST", { sessionId: meuId.current }).catch(() => {}); }
    try { pcRef.current && pcRef.current.close(); } catch { /* já fechada */ }
    (localRef.current ? localRef.current.getTracks() : []).forEach((t) => t.stop());
    pcRef.current = null; localRef.current = null; meuId.current = null;
    assinados.current = new Set(); donoDoMid.current = {}; ultimoBytes.current = 0;
    setLocal(null); setRemotos({});
    if (!silencioso) setFase("fora");
  };
  useEffect(() => () => sair(true), []); // eslint-disable-line react-hooks/exhaustive-deps

  const alternar = (tipo) => {
    const trilhas = localRef.current ? (tipo === "mic" ? localRef.current.getAudioTracks() : localRef.current.getVideoTracks()) : [];
    const novo = !(tipo === "mic" ? mic : cam);
    trilhas.forEach((t) => { t.enabled = novo; });
    tipo === "mic" ? setMic(novo) : setCam(novo);
  };

  const lista = Object.entries(remotos);
  const colunas = lista.length <= 1 ? "grid-cols-1" : lista.length <= 4 ? "md:grid-cols-2" : "md:grid-cols-3";

  return (
    <Caixa titulo="Turma (vários alunos) — pela Cloudflare">
      <p className="text-sm text-gray-600 mb-3">Mande este link para quem vai participar. Todos entram na mesma turma:</p>
      <div className="flex flex-wrap gap-2 items-center mb-4">
        <code className="bg-slate-100 rounded-lg px-3 py-2 text-xs break-all">{link}</code>
        <button onClick={() => navigator.clipboard && navigator.clipboard.writeText(link)} className="bg-slate-100 font-bold rounded-lg px-3 py-2 text-xs">Copiar link</button>
      </div>

      {(fase === "fora" || fase === "erro") && (
        <div className="flex flex-wrap gap-2 items-center">
          <input value={nome} onChange={(e) => setNome(e.target.value)} placeholder="Seu nome na turma" className="border rounded-lg px-3 py-2 text-sm" />
          <button onClick={entrar} className="bg-accent text-white font-bold rounded-lg px-4 py-2 text-sm">Entrar na turma</button>
        </div>
      )}
      {fase === "entrando" && <p className="text-sm text-gray-600">Ligando câmera e microfone… se o navegador perguntar, clique em <b>Permitir</b>.</p>}
      {fase === "erro" && <p className="mt-3 text-sm text-red-700 bg-red-50 border border-red-200 rounded-xl p-3">{erro}</p>}

      {fase === "dentro" && (
        <>
          <div className="relative">
            <div className={`grid gap-2 ${colunas}`}>
              {lista.length === 0 && <Video stream={null} rotulo="Turma aberta" className="w-full aspect-video rounded-xl" />}
              {lista.map(([id, p]) => <Video key={id} stream={p.stream} rotulo={p.nome} className="w-full aspect-video rounded-xl" />)}
            </div>
            <Video stream={local} mudo espelho rotulo={`${nome.trim() || "Você"}${cam ? "" : " · câmera desligada"}`}
              posicao="absolute" className="right-3 top-3 w-1/5 min-w-[7rem] aspect-video rounded-lg border-2 border-white/70 shadow-lg z-10" />
          </div>
          <div className="flex flex-wrap gap-2 justify-center mt-3">
            <button onClick={() => alternar("mic")} className={`rounded-full px-4 py-2 text-sm font-bold ${mic ? "bg-slate-100" : "bg-red-100 text-red-700"}`}>{mic ? "🎤 Microfone ligado" : "🔇 Microfone desligado"}</button>
            <button onClick={() => alternar("cam")} className={`rounded-full px-4 py-2 text-sm font-bold ${cam ? "bg-slate-100" : "bg-red-100 text-red-700"}`}>{cam ? "📷 Câmera ligada" : "🚫 Câmera desligada"}</button>
            <button onClick={() => sair(false)} className="rounded-full px-4 py-2 text-sm font-bold bg-red-600 text-white">Sair da turma</button>
          </div>
          <p className="text-xs text-gray-500 mt-2 text-center">{lista.length + 1} na turma{gb !== null ? ` · uso de vídeo no mês: ${Number(gb).toFixed(2)} GB de 1.000 GB grátis` : ""}</p>
        </>
      )}
    </Caixa>
  );
}

// ---------------------------------------------------------------- página
export default function ParceirosDemoPage() {
  const params = new URLSearchParams(window.location.search);
  const sala = useMemo(() => params.get("sala") || Math.random().toString(36).slice(2, 8), []); // eslint-disable-line react-hooks/exhaustive-deps
  const [aba, setAba] = useState(params.get("sala") ? "sala" : "candidato");
  const [modo, setModo] = useState(params.get("modo") === "turma" ? "turma" : "individual");
  const [pedido, setPedido] = useState(null);

  useEffect(() => {
    document.title = "Parceiros de capacitação · protótipo · eaiRH";
    const m = document.createElement("meta"); m.name = "robots"; m.content = "noindex, nofollow";
    document.head.appendChild(m);
    return () => { document.head.removeChild(m); };
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="max-w-4xl mx-auto px-4 md:px-6 py-8">
        <div className="bg-brand text-white rounded-2xl p-6 mb-6">
          <div className="text-xs font-extrabold tracking-widest uppercase text-orange-300">Protótipo · dados de exemplo</div>
          <h1 className="text-2xl md:text-3xl font-bold mt-1">Parceiros de capacitação</h1>
          <p className="text-sm text-blue-100 mt-2 max-w-2xl">Quem procura emprego no eaiRH e quer desenvolver uma skill (como inglês ou Excel) encontra professores e escolas
            verificados, avaliados pelos próprios alunos, com uma aula grátis agendada e feita dentro do portal. Grátis para o aluno, sem comissão para o parceiro.</p>
          <div className="grid grid-cols-3 gap-3 mt-4 text-center">
            {[["2.254", "vagas abertas pedem Excel"], ["1.775", "vagas abertas pedem inglês"], ["R$ 0", "de comissão para o parceiro"]].map(([n, t]) => (
              <div key={t} className="bg-white/10 rounded-xl p-3"><b className="block text-2xl text-orange-300">{n}</b><span className="text-xs text-blue-100">{t}</span></div>))}
          </div>
        </div>

        <div className="flex flex-wrap gap-2 mb-5">
          <Aba ativa={aba === "candidato"} onClick={() => setAba("candidato")}>Visão do candidato</Aba>
          <Aba ativa={aba === "parceiro"} onClick={() => setAba("parceiro")}>Painel do parceiro</Aba>
          <Aba ativa={aba === "sala"} onClick={() => setAba("sala")}>Sala de aula</Aba>
        </div>

        {aba === "candidato" && <VisaoCandidato pedido={pedido} setPedido={setPedido} irParaSala={() => setAba("sala")} />}
        {aba === "parceiro" && <VisaoParceiro pedido={pedido} setPedido={setPedido} />}
        {aba === "sala" && (
          <>
            {/* Turma em validação (17/10): por enquanto só aparece no PC do Nelson (localhost). */}
            {TURMA_LIBERADA && (
              <div className="flex flex-wrap gap-2 mb-3">
                <Aba ativa={modo === "individual"} onClick={() => setModo("individual")}>Aula individual (vídeo direto)</Aba>
                <Aba ativa={modo === "turma"} onClick={() => setModo("turma")}>Turma (vários alunos)</Aba>
              </div>
            )}
            {modo === "individual" || !TURMA_LIBERADA
              ? <SalaDeAula sala={sala} onRealizada={() => setPedido((p) => (p ? { ...p, status: "realizada" } : p))} />
              : <SalaTurma sala={sala} />}
          </>
        )}

        <p className="text-xs text-gray-400 text-center mt-8">Protótipo para conversa com parceiros. Nada aqui é enviado nem gravado, exceto a sala de vídeo, que é real.</p>
      </main>
    </div>
  );
}
